// JavaScript Document
// reset cookie
let urlCook = window.location.search;
if (urlCook.indexOf('?reset=local') !== -1) {
	Cookies.set('delivery-v6', 'local', { expires: date, domain: '.drinkbuchi.com' });
	console.log('local reset');
} 
// cart show minimum notification
if($('body').hasClass('template-cart')){  
setTimeout(function(){ 
$('#minimum-notification').css('opacity','1');
    }, 500);
}
	
// Full Validator
$(document).ready(function() { 
var addressInputField = document.getElementById('address-input');
    let autocomplete;
    (function () {
    autocomplete = new google.maps.places.Autocomplete(addressInputField, {
        types: ["address"],
        componentRestrictions: { country: ["us"] },
        fields: ["address_components"],
    });
        autocomplete.addListener('place_changed', onPlaceChanged);
    })();
    function onPlaceChanged() {
            let place = autocomplete.getPlace();
            let postcode = "";
            let address1 = "";
            if (!place.address_components) {
                //user did not select, reset input field
                addressInputField.placeholder =
                    'Enter your address';
            } else {
                //display results of valid place
				$("#validator-form__submit").removeClass("disabled");
				$(".validator-force-message").removeClass("show");
                for (const component of place.address_components) {
                    const componentType = component.types[0];

                    switch (componentType) {
                      case "street_number": {
                        address1 = `${component.long_name} ${address1}`;
                        break;
                      }
                      case "route": {
                        address1 += component.short_name;
                        Cookies.set('address1', address1, { domain: '.drinkbuchi.com' });   
                        break;
                      }
                      case "postal_code": {
                        postcode = `${component.long_name}${postcode}`;
                        Cookies.set('postcode', postcode, { domain: '.drinkbuchi.com' });   
                        break;
                      }                
                      case "locality":
                        Cookies.set('locality', component.long_name, { domain: '.drinkbuchi.com' });
                        break;

                      case "administrative_area_level_1": {
                        Cookies.set('state', component.short_name, { domain: '.drinkbuchi.com' });  
                        break;
                      }
                      case "country":
                        Cookies.set('country', component.long_name, { domain: '.drinkbuchi.com' });    
                        break;
                    } 
                  }
            }
        }
});
// hide content from audiences
function showContentBlocker() {
	$('.video-wrapper').addClass("pb-0");
	$('.btn.modal__close').addClass("d-none");
	$("#VideoHolder").html("<div style='width: 100%; max-width: 700px; margin: 0 auto;'><h1 class='caslon d-block' style='line-height: normal;'>Sorry!</h1><h1 class='product-message'>This product is not currently available for delivery in your area.</h1><h1 class='account-message'>We no longer ship to your area.</h1><p class='rte pt-1'>You can find Buchi near you using our <a title='Find Buchi near you' href='/pages/store-locator'>Store Locator</a>.</p></div>");
	$('body').addClass('modal-open video-modal-open modal-open--solid');
	$('#VideoModal').addClass('modal--is-active').hide().fadeIn();
}
function validatorLoading() {
    $("body").removeClass("local regional ineligible");
    $(".validator-message").removeClass("show hide");
    $(".validator-form__submit-label").addClass("hide");    
    $(".validator-form__submit-loading").addClass("show"); 
}
function validatorComplete() {
    $(".validator-form__submit-label").removeClass("hide");    
    $(".validator-form__submit-loading").removeClass("show"); 
}
$('.validator-drawer__teaser, .btn-verify, .mobile-verify').click( function() {
    $("#ValidatorDrawer").addClass('is--open'); 
    $("html").addClass('js-drawer-open'); 
    $("#validator-off").addClass('show'); 
}); 
$('.validator-drawer-close, #validator-off').click( function() {
    $("#ValidatorDrawer").removeClass('is--open'); 
    $("html").removeClass('js-drawer-open');
    $("#validator-off").removeClass('show');
	$(".validator-success-message").removeClass("show");
}); 


function localPricing() {
	$(".product-block--price.ineligible.show-pricing").attr( "style", "display: block; opacity: 1;" );	
}
function autoCloseValidator() {
	setTimeout(function () { 
		$(".cart-drawer-header .js-drawer-close").click();
		setTimeout(function () { 
			$("body").removeClass("no-cookie").addClass("local");
			$("body.force-validator").removeClass("force-validator");
			// scroll to for locals shop
			if($('body').is("#for-locals") ) {
				let localShopID = $('.collection-nav-wrapper').parent('.shopify-section').attr('id');
				console.log("localShopID is " + localShopID);
				$('html, body').animate({
					scrollTop: $("#" + localShopID).offset().top
				}, 1300);
			}
		}, 300);
    }, 2400);
}
function closeValidatorPortal() {
	setTimeout(function(){ 
		$("#ValidatorDrawer").fadeOut();
	}, 1300);
	sessionStorage.setItem("preValidated", "true");
}

var delivery = Cookies.get("delivery-v6");
if (delivery === undefined) {
    // cookie not present
	$("body").addClass("no-cookie");
    var date = new Date();
    date.setTime(date.getTime() + 180 * 24 * 60 * 60 * 1000);
	if ( $('body').hasClass("template-customers-login") || $('body').hasClass("template-customers-register") || $('body').hasClass("template-customers-account") || $('body').hasClass("template-customers-addresses") || $('body').hasClass("template-customers-order") || $('body').is("#drink-buchi") ) {
		$('body').addClass('force-validator');
	}
} else if ( delivery == "local"  ) {    
    // local
    $("body").addClass("local");
	
} else if ( delivery == "ineligible"  ) {
    // ineligible
    $("body").addClass("ineligible");
}
function validateAddress(e) {
    // Checks to ensure Store Pickup + Delivery is installed correctly.
   if (typeof window.Zapiet === 'undefined' || typeof window.ZapietCachedSettings === 'undefined' || 
       typeof window.Zapiet.DeliveryValidator === 'undefined' || window.ZapietCachedSettings.cached_config === 'undefined' || 
       window.ZapietCachedSettings.cached_config.delivery_validator === 'undefined') {
     console.warn('Zapiet - Custom delivery validator error. Please ensure you have Store Pickup + Delivery correctly installed. Contact support@zapiet.com for assistance.'); 
     return false;
    }
    
    validatorLoading();     
    var addressval = $("#address-input").val().toLowerCase();        
    var state = Cookies.get("state");
    
    var addressInput = document.getElementById('address-input').value;
  
    Zapiet.DeliveryValidator.checkEligiblity(addressInput, function(response) {
        // Eligible callback
        Zapiet.DeliveryValidator.eligibleForDelivery(response);
        // Eligible for local delivery
        Cookies.set('delivery-v6', 'local', { expires: date, domain: '.drinkbuchi.com' });
        validatorComplete();  
        $(".validator-success-message").addClass("show");
        localPricing();
		autoCloseValidator();
		if($('body').is("#drink-buchi") ) {
			closeValidatorPortal();
		}

    }, function() {
        // Not eligible callback
        Zapiet.DeliveryValidator.notEligibleForDelivery();

        // NOT eligible for local delivery
        Cookies.set('delivery-v6', 'ineligible', { expires: date, domain: '.drinkbuchi.com' }); 
		$("body").removeClass("no-cookie").addClass("ineligible");
		validatorComplete(); 
		$(".validator-ineligible-message").addClass("show");
		if( $('body').is("#drink-buchi")) {
			showContentBlocker();
		} 

    }, function() {
        // Error callback
        Zapiet.DeliveryValidator.error();
        console.log('Error');
        validatorComplete(); 
        $(".validator-error-message").addClass("show");
    });
        
   return false;
}

// QUANTITY UPDATER

  $('.plus').on('click',function(){
    var plusQty = $(this).parents('.product-quantity').find('.quantity__input');
    plusQty.val(parseInt(plusQty.val()) + 1 );
    if(plusQty.val() > 1) {
      $(this).parents('.product-quantity').find('.qty-case').html('cases');
      $(this).parents('.product-quantity').find('.qty-keg').html('kegs');
    }
    else {
      $(this).parents('.product-quantity').find('.qty-case').html('case');
      $(this).parents('.product-quantity').find('.qty-keg').html('keg');
    }
  });

  $(document).on('click','.minus',function(){
    var minusQty = $(this).parents('.product-quantity').find('.quantity__input');
    minusQty.val(parseInt(minusQty.val()) - 1 );
    if (minusQty.val() <= 1) {
      minusQty.val(1);
    }
    if(minusQty.val() > 1) {
      $(this).parents('.product-quantity').find('.qty-case').html('cases');
      $(this).parents('.product-quantity').find('.qty-keg').html('kegs');
    }
    else {
      $(this).parents('.product-quantity').find('.qty-case').html('case');
      $(this).parents('.product-quantity').find('.qty-keg').html('keg');
    }
  });

  $(function () {
    $("input#Quantity, input.quantity__input, input.cart__qty-input").keydown(function () {
      // Save old value.
      if (!$(this).val() || (parseInt($(this).val()) >= 1 && parseInt($(this).val()) >= 0))
        $(this).data("old", $(this).val());
      if($(this).val() > 1){
        $(this).parents('.product-quantity').find('.qty-case').html('cases');
        $(this).parents('.product-quantity').find('.qty-keg').html('kegs');
      }
      else {
        $(this).parents('.product-quantity').find('.qty-case').html('case');
        $(this).parents('.product-quantity').find('.qty-keg').html('keg');
      }
    });
    $("input#Quantity, input.quantity__input, input.cart__qty-input").keyup(function () {
      // Check correct, else revert back to old value.
      if (!$(this).val() || (parseInt($(this).val()) >= 1 && parseInt($(this).val()) >= 0))
        ;
      else
        $(this).val($(this).data("old"));


      if($(this).val() > 1){
        $(this).parents('.product-quantity').find('.qty-case').html('cases');
        $(this).parents('.product-quantity').find('.qty-keg').html('kegs');
      }
      else {
        $(this).parents('.product-quantity').find('.qty-case').html('case');
        $(this).parents('.product-quantity').find('.qty-keg').html('keg');
      }

    });

  });

// cart listeners
function cartQtyCheck(item_count) {
    if (item_count > 1) {
        $("body").addClass("cart-min");    
    } else {
        $("body").removeClass("cart-min");
    }
}
function getAllItemIDs(cartLV) {
	var allCartItems = cartLV.items;
	var exceptionInCart = false;
	for(var i=0; i < allCartItems.length; i++){
		var indProductID = allCartItems[i].product_id;
		// exceptions for keg and gift cards to always allow checkout
		if (indProductID == 6653838819363 || indProductID == 4623190818851) {
        	var exceptionInCart = true;   
		}
	}
	if (exceptionInCart == true) {
        $("body").addClass("exception-in-cart");  
	} else {
		$("body").removeClass("exception-in-cart");
	}
}
document.addEventListener('cart:updated', (event) => {
    var item_count = event.detail.cart.item_count;
	var cartLV = event.detail.cart;
    cartQtyCheck(item_count);
	getAllItemIDs(cartLV);
}); 

document.addEventListener('ajaxProduct:added', (event) => {
    jQuery.getJSON('/cart.js', function(cart) {
        var item_count = cart.item_count;
		var cartLV = cart;
        cartQtyCheck(item_count);  
		getAllItemIDs(cartLV);
		console.log('ajaxProduct:added just ran');
    });
});

document.addEventListener('cart:build', (event) => {
	jQuery.getJSON('/cart.js', function(cart) {
        var item_count = cart.item_count;
		var cartLV = cart;
        cartQtyCheck(item_count);  
		getAllItemIDs(cartLV);
    });
}); 


$(document).ready(function(){
    jQuery.getJSON('/cart.js', function(cart) {
        var item_count = cart.item_count;
		var cartLV = cart;
        cartQtyCheck(item_count); 
		getAllItemIDs(cartLV);
    });
}); 

// RECHARGE ACCOUNT ACCESS LINK
window.rcLoginAccessLink = {
disableInjection: true
};


function update_action(form){
    if (Cookies.get("address1")) {
        var address1 = "&checkout[shipping_address][address1]="+Cookies.get("address1");
    }
    if (Cookies.get("postcode")) {
        var postcode = "&checkout[shipping_address][zip]="+Cookies.get("postcode");
    }
    if (Cookies.get("locality")) {
        var locality = "&checkout[shipping_address][city]="+Cookies.get("locality");
    }
    if (Cookies.get("state")) {
        var state = "&checkout[shipping_address][province]="+Cookies.get("state");
    }
    if (Cookies.get("country")) {
        var country = "&checkout[shipping_address][country]="+Cookies.get("country");
    }
    var new_action; 
    var prefill = address1+postcode+locality+state+country;
    var form_action = form.action;
  	new_action = form_action+"&ref="+prefill;
    if( (form_action.indexOf("?") >= 0) ) {
      if(form_action.indexOf("ref")>=0) {
        new_action = form_action.replaceAt(form_action.indexOf("ref"),"ref="+prefill);
      }else{
        new_action = form_action+"&ref="+prefill;
      }
    }else{
      new_action = form_action+"?ref="+prefill;
    }
    $(form).attr("action",new_action);
} 

// change subscription widget verbiage  
if ( $( ".product-single__form" ).length ) {
$(window).on('load', function() { 
    function waitForEl() { 
        if (!window.ReChargeWidget || !window.ReChargeWidget.getWidgets()) { 
            // widget not found, reload function
            window.setTimeout(waitForEl,100);
        } else { 
            // widget has been found
            // Check if label has verbiage 
            var label = $('.rc_widget__option__discount').text().length;
            if (label > 0) { 
                var labelContent = $( ".rc_widget__option__discount" ).text().match(/\d+/);
                $( ".rc_widget__option__discount" ).text("– save" + " " + labelContent + "%:");
            } else { 
                window.setTimeout(waitForEl,100); 
            } 
        }
    };
    waitForEl();
});     
}
// contact page forms
if($('body').hasClass('contact-page')){  	
	function openContactForm() {
		$("#shopify-section-template--14198641000483__16485670384ae24e35").slideDown();
		$('html, body').animate({
        scrollTop: $("#shopify-section-template--14198641000483__16485670384ae24e35").offset().top
    }, 1300);
	}
	$("#shopify-section-template--14198641000483__16485670384ae24e35").hide(); 
	$('.form-dropdown__trigger').click( function() { 
		$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item').css('display','none');
		$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(1)').css('display','block');
		openContactForm();
	});
	$('.retailer-form__submit').click( function() {  
		let addressval = $("#retailer-zip-input").val();
		let zipval = addressval.substring(addressval.length - 5, addressval.length);
		let isnum = /^\d+$/.test(zipval);  	

		let zipsarray = ["28754","28714","28717","28657","28604","28605","28607","28655","28762","28716","28786","28779","28713","28789","28734","28741","28723","28712","28717","28774","28747","29303","29301","29307","29302","29306","29615","29662","29680","29681","29605","29611","28801","28803","28804","28805","28806","28787","28753","28786","27536","27537","28704","28711","28715","28730","28731","28732","28739","28743","28754","28773","28778","28779","28785","28790","28791","28792","29601","29607","29609","29617","29690"];
		if (isnum === true) {
			if(zipsarray.indexOf(zipval) >= 0) { 
				// DSD  
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item, #shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2) .acerill-custom-form').css('display','none');
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2), div[data-form-id="fc894470-9017-4ab6-b83e-01775c889907"]').css('display','block');
				$('div[data-form-id="fc894470-9017-4ab6-b83e-01775c889907"] input[id="3a97ac04-1cf0-4af9-bb64-1a9bb43f1b24"]').val(addressval);
				openContactForm();

			} else {
				// non-DSD
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item, #shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2) .acerill-custom-form').css('display','none');
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2), div[data-form-id="354c5bbf-3a92-4421-94f8-b9314b89567e"]').css('display','block');
				$('div[data-form-id="354c5bbf-3a92-4421-94f8-b9314b89567e"] input[id="3a97ac04-1cf0-4af9-bb64-1a9bb43f1b24"]').val(addressval);
				openContactForm();
			}
		}	
		});	
}	

// show pw on click
function showPass() {
  var pwinput = document.getElementById("CustomerPassword");
  if (pwinput.type === "password") {
    pwinput.type = "text";
  } else {
    pwinput.type = "password";
  }
}


// doc ready
$(document).ready(function(){	
	
// add active class to collection nav link	
let currentURL = window.location.pathname;
$('.collection-nav__item').each(function(){
  let collectionLink = $(this).attr('href');
  if (currentURL == collectionLink){
	$(this).parent().addClass('site-nav--active');
  }
}); 		
	
// SMOOTH SCROLING FOR JUMP LINKS Select all links with hashes   
// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('.nav-tabs__link')    
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
            }, 1300, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          }
        });
      }
    }
  });
	
// yotpo stars text adjustment
if($('body').hasClass('template-product')){  
	let starsNumber = $('.star-clickable .text-m').text().match(/\d+/);
	$('.star-clickable .text-m').text("(" + starsNumber + ") Reviews");
}

// keg special flavor picker
if($('.keg-flavor').length){  
	var firstKegFlavor = $('.keg-list-li:first-child > .other-drinks__list-link').text();
	$('.flavor-label').text(firstKegFlavor);
}	
var otherDrinkItems = $('.keg-flavor-list .keg-list-li').click(function() {
    var kegItemIndex = otherDrinkItems.index(this) + 2;
	var kegVariantTarget = $(this).parents('.keg-sub-nav').prev().find('.variant-input-wrap .variant-input:nth-child(' + kegItemIndex + ') > input');
	var kegVariantVal = kegVariantTarget.val();
	kegVariantTarget.click();
	$('.flavor-label').text(kegVariantVal);
	$('.is--keg-flavor-btn').click();
});	


// hide products, accounts, portal from ineligible
if ( $('body').hasClass('ineligible') ) {  
	if ( $('body').hasClass("template-customers-login") || $('body').hasClass("template-customers-register") || $('body').hasClass("template-customers-account") || $('body').hasClass("template-customers-addresses") || $('body').hasClass("template-customers-order") || $('body').is("#drink-buchi") ) {
		showContentBlocker();	
	}
}

	
// keep autoplaying Flickity sliders on mobile scroll	
if ( $(window).width() < 769 && $( ".is--slideshow-with-columns" ).length) {
    var flkty = Flickity.data('.is--slideshow-with-columns'); 
	flkty.on( 'pointerDown', function( event, pointer ) {
		flkty.playPlayer();
	});
}

// underline account link if in account page
if($('body').is("#account") ) {
	$('.custom-account').addClass("site-nav--active");
}	

// close nav on click, for anchors and verifyer
$('.slide-nav__link, .slide-nav__sublist-link').not('.js-toggle-submenu').click( function() { 
	$('.js-toggle-slide-nav').click();
});	
/*
// add portal shipping notification, check verification
if($('body').is("#drink-buchi") ) {
	// shipping notification
	$(".recharge-te").prepend("<div class='index-section index-section--alt text-center portal-notification'><div class='page-width'><h3 class='local audience'>A $40 minimum is required for delivery! Please make sure that your order has 2 or more cases of Buchi to qualify.</h3></div></div>");
	// force verification in portal if not Quick Action
	let preValidated = sessionStorage.getItem("preValidated");
	if (preValidated != "true" && window.location.href.indexOf('quick_actions') == -1) {
		$('body').addClass('force-validator');
	}
}	
*/
// avoid double validation if entering portal after Quick Action
$('#quickactions .qa-button').click( function() {
	sessionStorage.setItem("preValidated", "true");
}); 
	
// forcing validator dropdown choice	
$('#validator-form__submit').click( function(e) {
	if ($(this).hasClass('disabled')) {
		e.preventDefault();	
		$(".validator-force-message").addClass("show");
	} else {
		$(".validator-force-message").removeClass("show");
		validateAddress();
	}

}); 
let addressInputField = document.getElementById("address-input");
addressInputField.addEventListener("keydown", function(event) {
    if (event.key === "Enter") {
        // Enter key was hit
		if ($('#validator-form__submit').hasClass('disabled')) {
			$(".validator-force-message").addClass("show");
	} else {
		$(".validator-force-message").removeClass("show");
	}
    }
});	

// hiding acerill branding
if ( $( ".acerill-custom-form" ).length ) { 
	let checkExist = setInterval(function() {
	if ( $('.acerill-custom-form').last().find('form').length ) {    
	// Clear interval so this only runs once
	clearInterval(checkExist);
		$(".acerill-custom-form").each(function(){
			$(this).find('div').each(function(){
			let childText = $(this).text();
			if (childText === "Powered by Acerill Forms") {
				$(this).css('left','-500000px');
			}
			});
		});	
		
	} 
	}, 100); // check every 100ms	
}

	
});	// doc ready end	


window.onload = function(){
var api = new Yotpo.API(yotpo);
api.refreshWidgets();
};
